<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Produto - Edição</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'products'}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>

    <form-product :product="product" :update="true"></form-product>
</span>
</template>

<script>
import FormProductComponent from "./partial/FormProductComponent";

export default {
    name: "EditProductComponent",
    created() {
        this.loadProduct()
    },
    props: {
        prod_id: {
            require: true
        }
    },
    data() {
        return {
            product: {},
            langs: true
        }
    },
    methods: {
        loadProduct() {
            this.$store.dispatch('loadProduct', this.prod_id)
                .then(response => {
                    this.product = response
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: 'Erro',
                        text: 'Dados não localizado',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
        },
    },
    components: {
        formProduct: FormProductComponent
    }
};
</script>

<style scoped>

</style>
